import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';
import brasao from '../assets/brasao.png';

export const DialogPrintCaderno = ({
    visible,
    setVisible,
    cadernos,
    setCadernos,
    produtoAntigoPrint,
    produtoPrint
}) => {

    const cssText = `
    #print-content {
        font-family: 'Arial', sans-serif;
        width: 100%;
        padding: 20px;
    }

    .header table {
        margin-bottom: 15px;
    }

    .header th span {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    .header td {
        border-bottom: 1px solid #000;
        padding-bottom: 3px;
        min-height: 25px;
    }

    .header-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }

    .header-text {
        text-align: center;
        flex-grow: 1;
    }

    .header-text h2 {
        font-size: 16px;
        margin: 5px 0;
    }

    .header-text span {
        font-size: 12px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin: 10px 0;
        font-size: 12px;
    }

    th, td {
        border: 1px solid #000;
        padding: 6px;
        text-align: left;
    }

    th {
        background-color: #f0f0f0;
        font-weight: bold;
    }

    .section-title {
        font-size: 14px;
        font-weight: bold;
        margin: 15px 0 8px 0;
        text-align: left;
    }

    .subtitle {
        font-weight: bold;
        margin: 10px 0;
    }

    .page-break {
        page-break-after: always;
    }

    img {
        width: 70px;
        height: auto;
    }
        h4 {
    text-transform: uppercase;
    margin-bottom: 8px;
    font-size: 14px;
}

.checklist {
    margin-left: 20px;
    line-height: 1.6;
}

.checklist div {
    margin-bottom: 5px;
}

.input-line {
    display: inline-block;
    margin-right: 15px;
}
`;

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    };

    const renderCheckboxLine = (label, checked, indent = false, inline = false, width = '20%') => {
        return (
            <div style={{
                marginLeft: indent ? '20px' : '0',
                display: inline ? 'inline-block' : 'block',
                marginRight: inline ? '0' : '0',
                whiteSpace: 'nowrap',
                width: width,
                boxSizing: 'border-box',
                padding: '0 5px',
                verticalAlign: 'top'
            }}>
                ({checked ? '✓' : ' '}) {label}
            </div>
        );
    };

    const renderInputLine = (label, value, indent = false, inline = false) => {
        return (
            <div style={{
                marginLeft: indent ? '20px' : '0',
                display: inline ? 'inline-block' : 'block',
                marginRight: inline ? '15px' : '0',
                whiteSpace: 'nowrap',
                width: inline ? '20%' : 'auto',
                boxSizing: 'border-box',
                padding: '0 5px'
            }}>
                ({value ? '✓' : '  '}) {label} {value && `- ${value}`}
            </div>
        );
    };

    const renderPreparoSolo = (preparoSolo, praticasConservacionistas) => {
        return (
            <div>
                <h4>PREPARO DO SOLO</h4>
                <div style={{ marginLeft: '15px' }}>
                    <p>Operações realizadas:</p>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Não são necessárias", preparoSolo.naoNecessarias, false, true, '35%')}
                        {renderCheckboxLine("Subsolagem", preparoSolo.subsolagem, false, true, '20%')}
                        {renderCheckboxLine("Aração", preparoSolo.aracao, false, true, '20%')}
                        {renderCheckboxLine("Enxada Rotativa", preparoSolo.enxadaRotativa, false, true, '20%')}
                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Gradagem com grade", preparoSolo.gradagemComGrade, false, true, '35%')}
                        {renderCheckboxLine("Leve", preparoSolo.leve, false, true, '20%')}
                        {renderCheckboxLine("Pesada", preparoSolo.pesada, false, true, '20%')}
                        {renderCheckboxLine("Niveladora", preparoSolo.niveladora, false, true, '20%')}
                    </div>

                    {renderInputLine("Outras", preparoSolo.descricaoOutras)}

                    <p style={{ marginTop: '15px' }}>Adoção de práticas conservacionistas:</p>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Não são necessárias", praticasConservacionistas.naoNecessarias, false, true, '35%')}
                        {renderCheckboxLine("Plantio em nível", praticasConservacionistas.plantioEmNivel, false, true, '23%')}
                        {renderCheckboxLine("Terraços", praticasConservacionistas.terracos, false, true, '20%')}
                        {renderCheckboxLine("Rotação de culturas", praticasConservacionistas.rotacaoDeCulturas, false, true, '20%')}
                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Adubação verde", praticasConservacionistas.adubacaoVerde, false, true, '35%')}
                        {renderInputLine("Outras", praticasConservacionistas.descricaoOutras, false, true, '65%')}
                    </div>
                </div>
            </div>
        );
    };

    const renderSementesEMudas = (sementes) => {
        return (
            <div>
                <h4>SEMENTES E MUDAS</h4>
                <div style={{ marginLeft: '15px' }}>
                    <p>Operações realizadas:</p>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Não são necessárias", sementes.naoNecessarias, false, true, '33%')}
                        {renderCheckboxLine("Próprias", sementes.proprias, false, true, '33%')}
                        {renderCheckboxLine("Terceiros", sementes.terceiros, false, true, '33%')}
                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Viveiro com tratamento térmico", sementes.viveiroComTermico, false, true, '33%')}
                        {renderCheckboxLine("Viveiro sem tratamento térmico", sementes.viveiroSemTermico, false, true, '66%')}
                    </div>
                </div>
            </div>
        );
    };

    const renderIrrigacao = (irrigacao) => {
        return (
            <div>
                <h4>IRRIGAÇÃO</h4>
                <div style={{ marginLeft: '15px' }}>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        marginBottom: '5px'
                    }}>
                        {renderCheckboxLine("Não são necessárias", irrigacao.naoNecessarias, false, true, '35%')}
                    </div>

                    <>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            width: '100%',
                            marginBottom: '5px',
                            alignItems: 'center'
                        }}>
                            <span style={{
                                marginRight: '10px',
                                whiteSpace: 'nowrap'
                            }}>Sistema de irrigação:</span>

                            <span style={{
                                flexGrow: 1,
                                marginRight: '20px',
                                minHeight: '20px'
                            }}>{irrigacao.sistema || ' '}</span>

                            <span style={{
                                marginRight: '10px',
                                whiteSpace: 'nowrap'
                            }}>Origem da água:</span>

                            <span style={{
                                flexGrow: 1,
                                minHeight: '20px'
                            }}>{irrigacao.origem || ' '}</span>
                        </div>
                    </>
                </div>
            </div>
        );
    };

    const renderAdubacaoCorrecao = (adubacoes) => {
        if (!adubacoes || adubacoes.length === 0) return <p>Nenhuma adubação/correção registrada</p>;

        const formaDoseMapping = {
            'KG_M': 'Kg/m²',
            'L_M': 'L/m²',
            'G_PLANTA': 'g/Planta'
        };

        const formaAplicacaoMapping = {
            'PLANTIO': 'Plantio',
            'COBERTURA': 'Cobertura',
            'FOLIAR': 'Foliar',
            'FERTIRRIGACAO': 'Fertirrigação'
        };

        return (
            <div>
                <h4>Adubação e Correção</h4>
                <table width="100%" border="1" style={{ borderCollapse: 'collapse', textAlign: 'center' }} cellPadding="5px" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Produto/Fórmula</th>
                            <th>Dose</th>
                            <th>Forma de Aplicação</th>
                            <th>Responsável</th>
                            <th>Observação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {adubacoes.map((item, index) => (
                            <tr key={index}>
                                <td>{item.naoNecessarias ? "N/A" : formatDate(item.dataAplicacao)}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.nomeFormula}</td>
                                <td>{item.naoNecessarias ? "N/A" : `${item.dose} ${formaDoseMapping[item.formaDose] || item.formaDose}`}</td>
                                <td>{item.naoNecessarias ? "N/A" : formaAplicacaoMapping[item.formaAplicacao] || item.formaAplicacao}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.responsavelAplicacao}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.observacao || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderAplicacaoProdutosQuimicos = (aplicacoes) => {
        if (!aplicacoes || aplicacoes.length === 0) return <p>Nenhuma aplicação registrada</p>;

        const formaDoseMapping = {
            'KG_M': 'Kg/m²',
            'L_M': 'L/m²',
            'G_PLANTA': 'g/Planta'
        };

        return (
            <div>
                <h4>Aplicação de Produtos Químicos</h4>
                <table width="100%" border="1" style={{ borderCollapse: 'collapse', textAlign: 'center' }} cellPadding="5px" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Praga/Doença</th>
                            <th>Produto</th>
                            <th>Dose</th>
                            <th>Período Carência</th>
                            <th>Volume Calda</th>
                            <th>Operador</th>
                        </tr>
                    </thead>
                    <tbody>
                        {aplicacoes.map((item, index) => (
                            <tr key={index}>
                                <td>{item.naoNecessarias ? "N/A" : formatDate(item.data)}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.pragaDoencaAlvo}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.nomeProduto}</td>
                                <td>{item.naoNecessarias ? "N/A" : `${item.dose} ${formaDoseMapping[item.formaDose] || item.formaDose}`}</td>
                                <td>{item.naoNecessarias ? "N/A" : `${item.periodoCarencia ?? 0} ${(item.periodoCarencia ?? 0) < 2 ? "dia" : "dias"}`}</td>
                                <td>{item.naoNecessarias ? "N/A" : `${item.volumeCalda} L/ha`}</td>
                                <td>{item.naoNecessarias ? "N/A" : item.operador}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const header = (
        <div>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={reactToPrintFn} />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={header}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', height: '50vw' }}
        >
            <div id="print-content" ref={contentRef}>
                {cadernos.length > 0 ? cadernos.map((caderno, index) => (
                    <div className='contRomaneio' key={index}>
                        <table>
                            <tr>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '15%' }}>
                                    <div>
                                        <img
                                            style={{ width: 60, height: 'auto', margin: '0 auto' }}
                                            id="img"
                                            className='img'
                                            alt="brasao"
                                            src={brasao}
                                        />
                                    </div>
                                </th>
                                <th>
                                    <div className="header-section">
                                        <div className="header-text">
                                            <h4> <span> MUNICÍPIO DE PATOS DE MINAS / SEC. MUNICIPAL DE AGRIC. PEC. E ABASTECIMENTO </span>  <br />
                                                CEASA REGIONAL  <br />
                                                RELATÓRIO CADERNO DE CAMPO </h4>
                                        </div>
                                    </div>
                                </th>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '15%' }}>
                                    <div>
                                        <img
                                            style={{ width: 60, height: 'auto', margin: '0 auto' }}
                                            id="img"
                                            alt="Logo"
                                            className='img'
                                            src={logo}
                                        />
                                    </div>
                                </th>
                            </tr>
                        </table>

                        <hr />

                        <div className="p-d-flex p-ai-center p-flex-column header">
                            <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellPadding="5px" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '25%' }}>
                                            <strong>Código do Item:</strong> {caderno.id || "N/A"}
                                        </td>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '35%' }}>
                                            <strong>Produto Atual:</strong> {caderno.produtoPrint || caderno.produtoId || "N/A"}
                                        </td>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '40%' }}>
                                            <strong>Produto Anterior:</strong> {caderno.produtoAntigoPrint || caderno.produtoAntigoId || "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '25%' }}>
                                            <strong>Data de Plantio:</strong> {formatDate(caderno.dataPlantio)}
                                        </td>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '35%' }}>
                                            <strong>Data de Colheita:</strong> {formatDate(caderno.dataColheita)}
                                        </td>
                                        <td style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '40%' }}>
                                            <strong>Identificação da Área:</strong> {caderno.identificacaoArea || "N/A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <hr />

                        {renderPreparoSolo(caderno.preparoSolo, caderno.praticasConservacionistas)}
                        <hr />
                        {renderSementesEMudas(caderno.sementesEMudas)}
                        <hr />
                        {renderIrrigacao(caderno.irrigacao)}
                        <hr />
                        {renderAdubacaoCorrecao(caderno.adubacaoCorrecao)}
                        <hr />
                        {renderAplicacaoProdutosQuimicos(caderno.aplicacaoProdutosQuimicos)}

                        <footer id="rodape">
                            <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellPadding="5px" cellSpacing="0">
                                <thead>
                                    <tr></tr>
                                </thead>
                            </table>
                        </footer>
                    </div>
                )) : null}
            </div>
        </Dialog>
    );
}